var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"d-flex justify-center pt-2"},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}})],1),_c('div',{staticClass:"pt-5"},[_c('b',[_vm._v(_vm._s(_vm.$t('prescriptions.checking_collegiate_number_1')))]),_vm._v(" "+_vm._s(_vm.$t('prescriptions.checking_collegiate_number_2'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }